module.exports = require("@apollo/client/link/context");